import { render, staticRenderFns } from "./zoneEntrance.vue?vue&type=template&id=5d0570bd&scoped=true"
import script from "./zoneEntrance.vue?vue&type=script&lang=js"
export * from "./zoneEntrance.vue?vue&type=script&lang=js"
import style0 from "./zoneEntrance.vue?vue&type=style&index=0&id=5d0570bd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0570bd",
  null
  
)

export default component.exports